export const getOptionLabel = option => option.name;

export const isOptionEqual = (option, value) => option.value === value?.value;

export const findOptionByValue = (options, value) =>
  options.find(option => option.value === value) ?? null;

export const getOptionCategoryName = ({ categoryName }) => categoryName;
